import { ReportTemplate } from '../models/report-template.model';
import { TemplateExportListItemWithComments } from '../models/template-designer-state.model';

export function sortActivitiesByDate(
  items: TemplateExportListItemWithComments[]
): TemplateExportListItemWithComments[] {
  return [...items].sort((a, b) => {
    const dateA = a.startDate ?? a.activityDate;
    const dateB = b.startDate ?? b.activityDate;
    return (dateA ? new Date(dateA as string).getTime() : 0) - (dateB ? new Date(dateB as string).getTime() : 0);
  });
}

export function sortTemplateByDateDesc(templates: ReportTemplate[]): ReportTemplate[] {
  return [...templates].sort((a: ReportTemplate, b: ReportTemplate) => {
    const dateA = new Date(a?.updatedDttm || a?.createdDttm);
    const dateB = new Date(b?.updatedDttm || b?.createdDttm);
    if (dateA < dateB) {
      return 1;
    } else if (dateA > dateB) {
      return -1;
    }
    return 0;
  });
}
